export const viVN = {
  translation: {
    common: {
      loading: 'Đang tải...',
      error: 'Lỗi',
      button: 'Quay Về Trang Chủ',
      goToDashboard: 'Quay Về Trang Chủ',
    },
    noPermission: {
      title: 'Không Có Quyền Truy Cập',
      description: 'Bạn không có quyền truy cập vào trang này.',
      goToDashboardDescription: 'Bạn không có quyền truy cập vào trang này. Vui lòng liên hệ quản trị viên để được cấp quyền.',
      goToDashboardButton: 'Quay Về Trang Chủ',
    },
    'Add Fulfillment': 'Thêm Fulfillment',
    'Input Your data': 'Nhập dữ liệu của bạn',
    Name: 'Tên',
    Select: 'Chọn',
    search: {
      placeholder: 'Tìm kiếm',
    },
    login: {
      title: 'Đăng nhập Với Xinchuan Auth',
      button: 'Đăng nhập',
      success: 'Đăng nhập thành công',
      authCallback_authentication_failed: 'xác thực không thành công Xác thực gọi lại: {error}',
      authCallback_invalid_parameters: 'Xác thực các tham số gọi lại không hợp lệ',
      authCallback_invalid_state_parameter: 'Xác thực tham số trạng thái gọi lại không hợp lệ',
      authCallback_failed: 'Xác thực không thành công Gọi lại',
      authCallback_success: 'Xác thực đã được xác thực Gọi lại thành công',
      authCallback_completing_authentication: 'Xác thực gọi lại hoàn tất xác thực',
      authCallback_redirecting: 'Xác thực Chuyển hướng cuộc gọi lại',
    },
    sidebar: {
      overview: 'Tổng quan',
      operational: 'Vận hành',
      dashboard: 'Trang chủ',
      fulfillment: 'Quản lý thực hiện đơn hàng',
      addFulfillment: 'Thêm thực hiện đơn hàng',
      aggregator: 'Quản lý tích hợp',
      products: 'Sản phẩm',
      report: 'Báo cáo',
      wallet: 'Số dư ví',
      logout: 'Đăng xuất',
      product_group: 'Nhóm sản phẩm',
      product_management: 'Quản lý sản phẩm',
      voucherpin: 'Voucher PIN',
      voucher_pin_import: 'Nhập Voucher PIN',
    },
    pages: {
      wallet: 'Quản lý số dư ví',
      report: 'Trung tâm báo cáo',
      product_group: 'Nhóm sản phẩm',
      product_management: 'Quản lý sản phẩm',
    },
    Button: {
      Info: 'Thông tin',
      Success: 'Thành công',
      Error: 'Lỗi',
      Warning: 'Cảnh báo',
      Confirm: 'Xác nhận',
    },
    fileUpload: {
      uploading: 'Đang tải lên',
      attach_files: 'Tải lên bằng cách kéo và thả, dán hoặc nhấp vào đây',
      errors: {
        file_too_large: 'Kích thước tệp quá lớn. Kích thước tệp tối đa là {size}MB.',
        max_files: 'Số lượng tệp tối đa là {max}. Bạn còn {remaining} tệp còn lại.',
        invalid_content:
          'Nội dung tệp không hợp lệ. Vui lòng tải lên tệp hình ảnh hợp lệ (JPEG, PNG hoặc SVG).',
        upload_failed: 'Tải lên thất bại. Vui lòng thử lại.',
      },
      success: 'Tải lên thành công.',
      errors_upload_failed: 'Tải lên thất bại. Vui lòng thử lại.',
    },
    imageUpload: {
      uploading: 'Đang tải lên',
      attach_files: 'Tải lên bằng cách kéo và thả, dán hoặc nhấp vào đây',
      addPhoto: 'Thêm ảnh',
      main: 'Ảnh chính',
      setAsMain: 'Đặt làm ảnh chính',
      success: 'Tải ảnh lên thành công.',
      errors: {
        file_too_large: 'Kích thước tệp quá lớn. Kích thước tệp tối đa là {size}MB.',
        max_files: 'Số lượng tệp tối đa là {max}. Bạn còn {remaining} tệp còn lại.',
        invalid_content:
          'Nội dung tệp không hợp lệ. Vui lòng tải lên tệp hình ảnh hợp lệ (JPEG, PNG hoặc SVG).',
        upload_failed: 'Tải lên thất bại. Vui lòng thử lại.',
        not_image: 'Vui lòng chọn tệp hình ảnh.',
      },
    },
    pagination: {
      prev: 'Trước',
      next: 'Tiếp',
      prevPageAria: 'Trang trước',
      nextPageAria: 'Trang tiếp',
    },
    table: {
      filterReset: 'Đặt lại',
    },
    ui: {
      cancel: 'Hủy',
      imageCrop: {
        title: 'Tải ảnh lên',
        save: 'Lưu',
        invalid: 'Vui lòng tải ảnh JPG hoặc PNG tối đa {{max}} MB.',
      },
      emptyState: {
        noData: 'Không có dữ liệu',
      },
      chart: {
        noData: 'Không có dữ liệu biểu đồ.',
      },
      dateTimeRangeFilter: {
        startDate: 'Ngày bắt đầu',
        endDate: 'Ngày kết thúc',
      },
      statusBadge: {
        available: 'Khả dụng',
        unavailable: 'Không khả dụng',
        hidden: 'Ẩn',
        disabled: 'Vô hiệu',
        success: 'Thành công',
        pending: 'Đang chờ',
        failed: 'Thất bại',
        refunded: 'Đã hoàn tiền',
        uncertain: 'Không chắc chắn',
        processing: 'Đang xử lý',
      },
    },

    report: {
      selectSection: 'Chọn loại báo cáo từ menu',
      category: 'Danh mục báo cáo',
      fulfillment: {
        item: 'Thực hiện đơn hàng',
        title: 'Fulfillment mục',
        description: 'Tạo báo cáo mua hàng theo mục cho khoảng thời gian đã chọn',
        supplier: 'Nhà cung cấp',
        supplierPlaceholder: 'Chọn nhà cung cấp',
        period: 'Khoảng thời gian',
        export: 'Xuất',
      },
    },
    fulfillment: {
      empty: 'Không có fulfillment nào khớp với bộ lọc của bạn.',
      columns: {
        transactionId: 'ID giao dịch',
        invoiceNumber: 'Số hóa đơn',
        foreignOrderId: 'ID đơn hàng nước ngoài',
        status: 'Trạng thái',
        supplier: 'Nhà cung cấp',
        product: 'Sản phẩm',
        cost: 'Chi phí',
        walletBalance: 'Số dư ví',
        createdAt: 'Ngày tạo',
        fulfilledAt: 'Ngày hoàn thành',
        errorMessage: 'Thông tin lỗi',
      },
      filters: {
        transactionIdPlaceholder: 'ID giao dịch',
        invoiceNumberPlaceholder: 'Số hóa đơn',
        foreignOrderRefsPlaceholder: 'Nhập ref (Enter để thêm)',
      },
      suppliers: {
        alterra: 'Alterra',
        billfazz: 'Billfazz',
      },
      rowActions: {
        expandRow: 'Mở rộng hàng',
        collapseRow: 'Thu gọn hàng',
      },
      overview: {
        generalInfo: 'Thông tin chung',
        orderDetail: 'Chi tiết đơn hàng',
        notes: 'Ghi chú',
        destination: 'Đích đến',
        errorMessage: 'Thông tin Error',
        noErrorMessage: 'Không có thông tin Error',
        errorCode: 'Mã lỗi',
        vendorErrorCode: 'Mã lỗi nhà cung cấp',
        vendorErrorMessage: 'Thông tin lỗi nhà cung cấp',
      },
    },
    aggregator: {
      empty: 'Không có sản phẩm aggregator nào khớp với bộ lọc của bạn.',
      columns: {
        product: 'Sản phẩm',
        sku: 'Mã SKU',
        type: 'Loại',
        status: 'Trạng thái',
        actions: 'Thao tác',
        errorMessage: 'Thông tin Error',
        vendorCost: 'Chi phí mua hàng',
      },
      type: {
        prepaid: 'Trả trước',
        postpaid: 'Trả sau',
      },
      filters: {
        productPlaceholder: 'Sản phẩm',
        idPlaceholder: 'ID',
        available: 'Khả dụng',
        unavailable: 'Không khả dụng',
      },
      status: {
        available: 'Khả dụng',
        unavailable: 'Không khả dụng',
      },
      rowActions: {
        action: 'Thao tác',
        edit: 'Chỉnh sửa',
        enable: 'Bật',
        disable: 'Tắt',
        expandRow: 'Mở rộng hàng',
        collapseRow: 'Thu gọn hàng',
      },
      statusModal: {
        disableTitle: 'Tắt sản phẩm?',
        enableTitle: 'Bật sản phẩm?',
        disableConfirm: 'Tắt',
        enableConfirm: 'Bật',
        cancel: 'Hủy',
        warningTitle: 'Cảnh báo',
        disableImpact:
          'Khi tắt sản phẩm này, khách hàng sẽ không thể mua cho đến khi được bật lại.',
        disableSuccess: 'Đã tắt sản phẩm thành công',
        enableSuccess: 'Đã bật sản phẩm thành công',
        disablePrompt: 'Bạn có chắc muốn tắt',
        enablePrompt: 'Bạn có chắc muốn bật',
        disableNote: 'Sản phẩm sẽ vẫn bị tắt cho đến khi được bật lại thủ công.',
        enableNote: 'Hành động này sẽ làm cho sản phẩm sẵn sàng để fulfillment.',
      },
      overview: {
        generalInfo: 'Thông tin chung',
        aggregatorInfo: 'Thông tin aggregator',
        name: 'Tên',
        vendor: 'Nhà cung cấp',
        vendorSku: 'SKU',
        priority: 'Ưu tiên',
        procurementCost: 'Chi phí mua hàng',
      },
      editModal: {
        title: 'Chỉnh sửa sản phẩm',
        saveChanges: 'Lưu thay đổi',
        productInfo: 'Thông tin sản phẩm',
        productName: 'Tên sản phẩm',
        aggregatorMappings: 'Ánh xạ aggregator',
        aggregatorColumn: 'Nhà tích hợp',
        updateSuccess: 'Cập nhật sản phẩm thành công',
      },
    },
    productGroup: {
      empty: 'Không có nhóm sản phẩm nào khớp với bộ lọc của bạn.',
      columns: {
        product: 'Sản phẩm',
        price: 'Giá',
        actions: 'Thao tác',
      },
      actions: {
        import: 'Nhập',
        export: 'Xuất',
        newGroup: 'Nhóm mới',
      },
      rowActions: {
        action: 'Thao tác',
        edit: 'Sửa',
        editProduct: 'Sửa sản phẩm',
        addChild: 'Thêm mục con',
        addPlanGroup: 'Thêm nhóm gói',
        attachProduct: 'Gắn sản phẩm',
        changeOrder: 'Đổi thứ tự',
        detachProduct: 'Gỡ sản phẩm',
        enable: 'Bật',
        disable: 'Tắt',
        delete: 'Xóa',
        expandRow: 'Mở rộng hàng',
        collapseRow: 'Thu gọn hàng',
      },
      modals: {
        createTitle: 'Thêm nhóm mới',
        editGroupTitle: 'Sửa nhóm',
        changeOrderTitle: 'Đổi thứ tự',
        changeOrderEmpty: 'Nhóm này chưa có sản phẩm',
        saveChanges: 'Lưu thay đổi',
        reorder: 'Kéo để sắp xếp',
        orderSaved: 'Đã lưu thứ tự',
        editProductTitle: 'Sửa sản phẩm',
        attachTitle: 'Gắn sản phẩm',
        deleteTitle: 'Xóa Nhóm',
        deleteProductTitle: 'Xóa Sản Phẩm',
        detachTitle: 'Gỡ sản phẩm',
        deletePrompt: 'Bạn có chắc muốn xóa "<bold>{{name}}</bold>" không?',
        deleteProductPrompt: 'Bạn có chắc muốn xóa "<bold>{{name}}</bold>" này không?',
        deleteConfirm: 'Xóa',
        deleteNote: 'Bạn không thể hoàn tác hành động này.',
        deleteImpact:
          'Khi xóa nhóm này, các bản ghi liên quan có thể mất tham chiếu nhóm và một số thao tác có thể không còn dùng được.',
        detachPrompt: 'Bạn có chắc muốn gỡ "<bold>{{name}}</bold>"?',
        groupInformation: 'Thông tin nhóm',
        name: 'Tên',
        namePlaceholder: 'Nhập tên',
        nameRequired: 'Tên là bắt buộc',
        photo: 'Ảnh',
        groupType: 'Loại nhóm',
        section: 'Phần',
        sectionPlaceholder: 'Chọn phần',
        sectionRequired: 'Phần là bắt buộc',
        parentGroup: 'Nhóm cha',
        parentPlaceholder: 'Chọn nhóm cha',
        hidden: 'Ẩn',
        upload: 'Tải lên',
        changeImage: 'Đổi ảnh',
        removeImage: 'Xóa ảnh',
        imageHint: '*Chỉ định dạng <bold>ảnh</bold> (tối đa <bold>2MB</bold>)',
        imageTransparent:
          'Ảnh cần <bold>nền trong suốt</bold> để nhìn thấy nền xanh.',
        imageTypeError: 'Ảnh phải là JPG, PNG hoặc JPEG.',
        imageSizeError: 'Ảnh tối đa 2 MB.',
        types: {
          subgroup: 'Nhóm con',
          product: 'Sản phẩm',
          esimCountry: 'Quốc gia ESIM',
        },
        sections: {
          dataPerDay: 'Dữ liệu mỗi ngày',
          dataInTotal: 'Tổng dữ liệu',
        },
        save: 'Lưu Thay Đổi',
        createGroup: 'Tạo nhóm',
        cancel: 'Hủy',
        yes: 'Có',
        no: 'Không',
        attach: 'Gắn sản phẩm',
        product: 'Sản phẩm',
        products: 'Sản phẩm',
        selectProduct: 'Chọn sản phẩm',
        noProducts: 'Không có sản phẩm phù hợp.',
        loadingProducts: 'Đang tải sản phẩm…',
        attachLoadError: 'Không tải được sản phẩm',
        productName: 'Tên sản phẩm',
        price: 'Giá',
        availability: 'Tình trạng',
        available: 'Có sẵn',
        notAvailable: 'Không có sẵn',
        productStatus: 'Trạng thái sản phẩm',
        enabled: 'Bật',
        disabled: 'Tắt',
        visibility: 'Hiển thị',
        visible: 'Hiện',
        refundable: 'Hoàn tiền được',
        productDisabled: 'Sản phẩm đã tắt',
        availableHint: 'Có thể mua sản phẩm',
        notAvailableHint: 'Không thể mua sản phẩm',
        visibleHint: 'Hiển thị trong danh sách',
        hiddenHint: 'Ẩn khỏi danh sách',
        enabledHint: 'Sản phẩm đang hoạt động',
        disabledHint: 'Sản phẩm không hoạt động',
        refund: 'Hoàn tiền',
        nonRefundable: 'Không hoàn tiền',
        refundableHint: 'Sản phẩm đủ điều kiện hoàn tiền',
        nonRefundableHint: 'Sản phẩm không đủ điều kiện hoàn tiền',
        locale: 'Ngôn ngữ',
        description: 'Mô tả',
        descriptionPlaceholder: 'Nhập mô tả',
        rootParent: 'Không (gốc)',
        created: 'Đã tạo nhóm',
        updated: 'Đã cập nhật nhóm',
        productUpdated: 'Đã cập nhật sản phẩm',
        deleted: 'Đã xóa "{{name}}"',
        productDeleted: 'Đã xóa "{{name}}"',
        detached: 'Đã gỡ "{{name}}"',
        attached: 'Đã gắn sản phẩm',
      },
      statusModal: {
        disableTitle: 'Tắt sản phẩm?',
        enableTitle: 'Bật sản phẩm?',
        disableConfirm: 'Tắt',
        enableConfirm: 'Bật',
        cancel: 'Hủy',
        warningTitle: 'Cảnh báo',
        disableImpact:
          'Khi tắt sản phẩm này, khách hàng sẽ không thể mua cho đến khi được bật lại.',
        disableSuccess: 'Đã tắt sản phẩm thành công',
        enableSuccess: 'Đã bật sản phẩm thành công',
        disablePrompt: 'Bạn có chắc muốn tắt',
        enablePrompt: 'Bạn có chắc muốn bật',
        disableNote: 'Sản phẩm sẽ vẫn bị tắt cho đến khi được bật lại thủ công.',
        enableNote: 'Hành động này sẽ làm cho sản phẩm sẵn sàng để mua lại.',
      },
    },
    productManagement: {
      empty: 'Không có sản phẩm nào khớp với bộ lọc của bạn.',
      columns: {
        product: 'Sản phẩm',
        priceScheme: 'Schema giá',
        schemes: {
          fixed: 'Cố định',
          per_account: 'Theo tài khoản',
          user_defined: 'Người dùng định nghĩa',
        },
        price: 'Giá',
        type: 'Loại',
        types: {
          unit: 'Đơn vị',
          bundle: 'Gói',
        },
        description: 'Mô tả',
        status: 'Trạng thái',
        actions: 'Thao tác',
      },
      status: {
        available: 'Có sẵn',
        unavailable: 'Không có sẵn',
        hidden: 'Ẩn',
        disabled: 'Vô hiệu',
      },
      actions: {
        import: 'Nhập',
        export: 'Xuất',
        changeOrder: 'Đổi thứ tự',
      },
      export: {
        title: 'Xuất',
        provider: 'Nhà cung cấp',
        allProviders: 'Tất cả nhà cung cấp',
        medium: 'Phương tiện',
        allMediums: 'Tất cả phương tiện',
        electronic: 'Điện tử',
        voucherPin: 'Voucher PIN',
        supplier: 'Nhà cung ứng',
        allSuppliers: 'Tất cả nhà cung ứng',
        cancel: 'Hủy',
        export: 'Xuất',
        exported: 'Đã xuất sản phẩm',
        failed: 'Xuất thất bại',
        stillProcessing: 'Bản xuất vẫn đang được xử lý',
        unitHint: 'Tệp chỉ gồm sản phẩm đơn vị.',
      },
      changeOrder: {
        title: 'Đổi thứ tự',
        provider: 'Nhà cung cấp',
        selectProvider: 'Chọn nhà cung cấp',
        cancel: 'Hủy',
        saveChanges: 'Lưu thay đổi',
        saved: 'Đã lưu thứ tự sản phẩm {{provider}}',
      },
      import: {
        title: 'Nhập tệp',
        uploadData: 'Tải dữ liệu lên',
        downloadTemplate: 'Tải <template>mẫu</template> để xem định dạng bắt buộc.',
        dropHint: 'Nhấp hoặc kéo tệp vào khu vực này để tải lên',
        singleFile: 'Bạn chỉ có thể tải lên một tệp.',
        formats: 'Định dạng hỗ trợ: XLSX, XLS, và CSV.',
        cancel: 'Hủy',
        upload: 'Tải lên',
        data: 'Dữ liệu',
        status: 'Trạng thái',
        errorDetails: 'Chi tiết lỗi',
        valid: 'Hợp lệ',
        invalid: 'Không hợp lệ',
        missingColumn: 'Thiếu cột',
        successNote: 'Chỉ các hàng thành công mới được tải lên',
        invalidType: 'Vui lòng tải lên tệp XLSX.',
        imported: 'Đã nhập sản phẩm',
        started: 'Đã bắt đầu nhập',
        failed: 'Nhập thất bại',
        skipped: '{{count}} dòng bị bỏ qua',
        stillProcessing: 'Bản nhập vẫn đang được xử lý',
        row: 'Dòng',
        field: 'Trường',
        message: 'Thông báo',
        summary: 'Đã ghi {{written}} sản phẩm. Bỏ qua {{skipped}}.',
        logNote: 'Xem các dòng không được ghi.',
        noneValid: 'Không có cột hợp lệ để nhập',
        columns: {
          id: 'ID',
          name: 'Tên',
          fapiao_name: 'Tên Fapiao',
          medium: 'Phương tiện',
          price: 'Giá',
          reference_cost_price: 'Giá vốn',
          price_scheme: 'Cách tính giá',
          supplier_product_code: 'Mã sản phẩm nhà cung cấp',
          denomination_currency: 'Đơn vị mệnh giá',
          denomination: 'Mệnh giá',
          type: 'Loại',
        },
      },
      rowActions: {
        action: 'Thao tác',
        setInstruction: 'Đặt hướng dẫn',
        edit: 'Sửa',
        enable: 'Bật',
        disable: 'Tắt',
      },
      instruction: {
        title: 'Đặt hướng dẫn',
        locale: 'Ngôn ngữ',
        instruction: 'Hướng dẫn',
        placeholder: 'Nhập hướng dẫn',
        add: 'Thêm hướng dẫn',
        remove: 'Xóa hướng dẫn',
        cancel: 'Hủy',
        saveChanges: 'Lưu thay đổi',
        saved: 'Đã lưu hướng dẫn',
      },
      edit: {
        title: 'Sửa sản phẩm',
        photoLabel: 'Ảnh',
        cancel: 'Hủy',
        back: 'Quay lại',
        next: 'Tiếp',
        saveChanges: 'Lưu thay đổi',
        saved: 'Đã cập nhật sản phẩm',
        photo: 'Ảnh',
        uploadTitle: 'Tải ảnh lên',
        uploadSave: 'Lưu',
        name: 'Tên',
        description: 'Mô tả',
        descriptionPlaceholder: 'Nhập mô tả',
        locale: 'Ngôn ngữ',
        imageHint: '*Chỉ định dạng ảnh (tối đa 2MB)',
        imageTransparent: 'Ảnh cần nền trong suốt để nhìn thấy nền xanh.',
        steps: {
          info: 'Thông tin sản phẩm',
          details: 'Chi tiết sản phẩm',
          visibility: 'Hiển thị & truy cập',
        },
        pricing: 'Giá',
        priceScheme: 'Schema giá',
        priceCurrency: 'Tiền tệ giá',
        price: 'Giá',
        priceBundleHint: 'Giá này theo gói. Hãy đổi ở giá gói.',
        referenceCostCurrency: 'Tiền tệ giá vốn',
        referenceCostPrice: 'Giá vốn tham chiếu',
        denominationCurrency: 'Tiền tệ mệnh giá',
        denomination: 'Mệnh giá',
        productDetails: 'Chi tiết sản phẩm',
        medium: 'Hình thức',
        type: 'Loại',
        supplierProductCode: 'Mã sản phẩm nhà cung ứng',
        productBundle: 'Gói sản phẩm',
        bundleSearch: 'Vd. IF hoặc IF 50 NT',
        bundleCount: '{{count}} mục',
        total: 'Tổng',
        availability: 'Tình trạng',
        available: 'Có sẵn',
        availableHint: 'Sản phẩm có thể mua',
        notAvailable: 'Không có sẵn',
        notAvailableHint: 'Sản phẩm không thể mua',
        productStatus: 'Trạng thái sản phẩm',
        enabled: 'Bật',
        enabledHint: 'Sản phẩm đang hoạt động',
        disabled: 'Tắt',
        disabledHint: 'Sản phẩm không hoạt động',
        visibility: 'Hiển thị',
        visible: 'Hiện',
        visibleHint: 'Xuất hiện trong danh sách',
        hidden: 'Ẩn',
        hiddenHint: 'Ẩn khỏi danh sách',
        access: 'Quyền truy cập',
        publicAccess: 'Truy cập công khai',
        publicAccessHint: 'Hiển thị với mọi người dùng',
        restrictedAccess: 'Truy cập hạn chế',
        restrictedAccessHint: 'Chỉ hiển thị với một số người dùng',
        refundable: 'Hoàn tiền được',
        schemes: { fixed: 'Cố định', per_account: 'Theo tài khoản', user_defined: 'Người dùng định nghĩa' },
        mediums: { voucher_pin: 'PIN voucher', electronic: 'Điện tử' },
        types: { unit: 'Đơn vị', bundle: 'Gói' },
        bundleColumns: {
          product: 'Sản phẩm',
          qty: 'SL',
          price: 'Giá',
          subtotal: 'Tạm tính',
          action: 'Thao tác',
        },
      },
    },
    wallet: {
      average_spending_per_day: 'Chi tiêu trung bình mỗi ngày',
      history: 'Lịch sử số dư',
      chart_balance: 'Số dư',
      chart_change: 'Thay đổi',
      columns: {
        provider: 'Nhà cung cấp',
      },
    },
    voucherPinImport: {
      title: 'Nhập Voucher PIN',
      search: 'Tìm mã hoặc tên SKU',
      skuId: 'ID SKU',
      status: 'Trạng thái',
      template: 'Tải mẫu',
      uploadButton: 'Tải tệp lên',
      empty: 'Không có lô nhập',
      ownBatches: 'Chỉ hiển thị lô do bạn tạo.',
      columns: {
        batch: 'Lô',
        sku: 'SKU',
        file: 'Tệp',
        source: 'Nguồn',
        status: 'Trạng thái',
        cost: 'Chi phí',
        rows: 'Đã xử lý',
        errors: 'Lỗi',
        accepted: 'Chấp nhận',
        createdAt: 'Tạo lúc',
        action: 'Thao tác',
      },
      statuses: {
        uploaded: 'Đã tải lên',
        ready: 'Sẵn sàng',
        preflight_failed: 'Kiểm tra lỗi',
        committed: 'Đã ghi',
        failed: 'Thất bại',
        cancelled: 'Đã hủy',
        expired: 'Hết hạn',
      },
      actions: { view: 'Xem', commit: 'Ghi nhận', cancel: 'Hủy' },
      confirm: {
        commitTitle: 'Ghi nhận lô này?',
        commitBody: 'Mã PIN sẵn sàng sẽ được đưa vào kho.',
        cancelTitle: 'Hủy lô này?',
        cancelBody: 'Lô này sẽ không được nhập.',
        yes: 'Có',
        no: 'Không',
      },
      upload: {
        title: 'Tải tệp PIN',
        hint: 'Tệp phải là .xlsx hoặc .csv với tiêu đề pin_code.',
        skuId: 'ID SKU',
        drop: 'Thả tệp .xlsx hoặc .csv vào đây',
        costPrice: 'Giá vốn',
        currency: 'Tiền tệ',
        autoCommit: 'Tự ghi nhận khi kiểm tra đạt',
        cancel: 'Hủy',
        submit: 'Tải lên',
        skuRequired: 'Nhập ID SKU đã có.',
        fileRequired: 'Chọn tệp .xlsx hoặc .csv.',
        costInvalid: 'Chi phí phải là số thập phân tối đa 4 chữ số, ví dụ 142.5000.',
        currencyInvalid: 'Tiền tệ phải gồm 3 chữ cái, ví dụ TWD.',
        failed: 'Tệp không được chấp nhận.',
      },
      detail: {
        title: 'Lô nhập',
        close: 'Đóng',
        loading: 'Đang tải lô...',
        missing: 'Không tải được lô này.',
        row: 'Dòng',
        stage: 'Giai đoạn',
        message: 'Thông báo',
        noLogs: 'Chưa có nhật ký.',
      },
    },
  },
};
